import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, ScrollRestoration } from 'react-router-dom';
import { Toaster } from 'sonner';

import SiteLayout from '@/layout/SiteLayout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Courses from '@/pages/Courses';
import StandardCourse from '@/pages/StandardCourse';
import BeginnerCourse from '@/pages/BeginnerCourse';
import FEndorsement from '@/pages/FEndorsement';
import NZQA from '@/pages/NZQA';
import Location from '@/pages/Location';
import Booking from '@/pages/Booking';
import Admin from '@/pages/Admin';
import NotFound from '@/pages/NotFound';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/standard" element={<StandardCourse />} />
            <Route path="/courses/beginner" element={<BeginnerCourse />} />
            <Route path="/courses/f-endorsement" element={<FEndorsement />} />
            <Route path="/courses/nzqa" element={<NZQA />} />
            <Route path="/location" element={<Location />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
